import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=981b5af4&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=981b5af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981b5af4",
  null
  
)

export default component.exports